module.exports = __webpack_public_path__ + "img/500.e7aa8be3.png";